

import {
  CopyBtn,
} from "components/buttons/copy_btn"
import $ from "jquery"
import Notifier from "app/notifier"


import I18n from "plugins/i18n-js"


interface InputSelector {
  scope?: string
  button?: string
}
const default_selector = {
  scope:  "body",
  button: ".cell--shared--copyable-url-box .cell--shared--copyable-url-box__zeroclipboard-button",
}


class CopyUrlButtonBluePrint extends CopyBtn {
  constructor(selector?: InputSelector){
    const merged_selector = Object.assign({}, default_selector, selector)
    super(merged_selector)
  }

  protected onSuccess(e: ClipboardJS.Event){
    Notifier.showSuccess(I18n.t("js.app.notifier.listings.url_copied"), 3000)
    super.onSuccess(e)
  }
}

const Factory = {
  create(selector?: InputSelector){
    const tmp = Object.assign({}, default_selector, selector)
    const btns = $(tmp.scope).find(tmp.button)
    return btns.map((idx, el) => {
      return new CopyUrlButtonBluePrint(Object.assign(tmp, {button: el}))
    })
  },
}

export {
  Factory as default,
  Factory,
}
